import { CommonModule, DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { VehicleRecurrenceApiService } from '@/app/modules/vehicle-recurrence/infra/api.service';
import {
  RecurrenceTypeEnum,
  VehicleStatusItem,
  VehicleStatusResponse,
} from '@/app/modules/vehicle-recurrence/core/type';
import { normalizePlate } from '@/app/common/utils/plate/normalize-plate';

@Component({
  selector: 'app-vehicle-status-panel',
  standalone: true,
  templateUrl: './status-panel.component.html',
  styleUrls: ['./status-panel.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    NzCardModule,
    NzGridModule,
    NzTagModule,
    NzIconModule,
    NzToolTipModule,
    NzEmptyModule,
    NzInputModule,
    NzTabsModule,
    NzButtonModule,
  ],
  providers: [DatePipe],
})
export class VehicleStatusPanelComponent implements OnInit {
  @Input() isMonitorMode = false;

  loading = false;

  emDia: VehicleStatusItem[] = [];
  atrasado: VehicleStatusItem[] = [];
  semRecorrencia: VehicleStatusItem[] = [];

  displayEmDia: VehicleStatusItem[] = [];
  displayAtrasado: VehicleStatusItem[] = [];
  displaySemRecorrencia: VehicleStatusItem[] = [];

  searchOnTime = '';
  searchOverdue = '';
  searchNoConfig = '';

  constructor(private api: VehicleRecurrenceApiService) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    this.api.getVehiclesStatus().subscribe({
      next: (data: VehicleStatusResponse) => {
        this.emDia = data.em_dia || [];
        this.atrasado = data.atrasado || [];
        this.semRecorrencia = data.sem_recorrencia || [];
        this.applyFilters();
        this.loading = false;
      },
      error: () => {
        this.emDia = [];
        this.atrasado = [];
        this.semRecorrencia = [];
        this.applyFilters();
        this.loading = false;
      },
    });
  }

  applyFilters() {
    this.displayEmDia = this.filterList(this.emDia, this.searchOnTime);
    this.displayAtrasado = this.filterList(this.atrasado, this.searchOverdue);
    this.displaySemRecorrencia = this.filterList(
      this.semRecorrencia,
      this.searchNoConfig,
    );
  }

  private filterList(list: VehicleStatusItem[], term: string) {
    const q = normalizePlate(term || '');
    if (!q) return [...list];
    return list.filter(
      (i) =>
        normalizePlate(i.chassis).includes(q) ||
        (i.lastChecklistUserName || '').toUpperCase().includes(term.trim().toUpperCase()),
    );
  }

  describeRecurrence(item: VehicleStatusItem): string {
    if (!item.recurrenceType) return 'Sem recorrência';
    if (item.recurrenceType === RecurrenceTypeEnum.INTERVAL_DAYS) {
      return `A cada ${item.intervalDays ?? '-'} dia(s)`;
    }
    if (item.recurrenceType === RecurrenceTypeEnum.WEEK_DAYS) {
      const names = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
      const days = (item.weekDays ?? [])
        .slice()
        .sort((a, b) => a - b)
        .map((d) => names[d])
        .join(', ');
      return days ? `Toda(s) ${days}` : 'Sem dias definidos';
    }
    return '-';
  }
}
